import { klaviyoConfig } from "@/lib/klaviyo-client/klaviyo-config"

export const fieldPlaceholder: Map<string, string> = new Map()

fieldPlaceholder.set("Email", "e.g. name@pocsports.com")
fieldPlaceholder.set("Firstname", "e.g. Adam")
fieldPlaceholder.set("Lastname", "e.g. Smith")
fieldPlaceholder.set("address1", "e.g. 1234 Main St")
fieldPlaceholder.set("zipCode", "e.g. 00000")
fieldPlaceholder.set("city", "e.g. Berlin")
fieldPlaceholder.set("phoneNumber", "e.g. +000 123 456 7890")

export const fieldLabel: Map<string, string> = new Map()

fieldLabel.set("Email", "Email")
fieldLabel.set("Firstname", "First name")
fieldLabel.set("Lastname", "Last name")
fieldLabel.set("address1", "Address")
fieldLabel.set("address2", "Address Line 2 (Optional)")
fieldLabel.set("zipCode", "Zipcode")
fieldLabel.set("city", "City")
fieldLabel.set("State", "State")
fieldLabel.set("phoneNumber", "Phone Number")

// Convert the klaviyoFormCodes object into a Map
// const isProduction = process.env.VERCEL_GIT_COMMIT_REF === "main" || process.env.VERCEL_GIT_COMMIT_REF === "main-cms-preview";
const isProduction = process.env.NEXT_PUBLIC_KLAVIYO_ID === "R8UBuv"
const environment = isProduction ? "production" : "qa"
export const klaviyoFormCodesMap: Map<string, string> = new Map(
    Object.entries(klaviyoConfig.checkoutMembershipForm[environment])
)
